module.exports = __webpack_public_path__ + "static/img/inner_banner2.jpg";